import React from 'react';
import { FormattedMessage, FormattedHTMLMessage, injectIntl, intlShape } from 'react-intl';

const Footer = ({ intl }) => (
  <footer className="footer">
    <div className="footer__copyright">
      <div className="container">
        <div className="row">
          <div className="col">
            <FormattedHTMLMessage id="footer.copyright" />
          </div>
        </div>
      </div>
    </div>
    <div className="footer__navigation">
      <div className="container">
        <div className="row">
          <div className="col col-12 col-md-8">
            <div className="footer__links">
              <a className="footer__link" href={intl.formatMessage({id: 'footer.privacy.url'})} target="_blank">
                <FormattedMessage id="footer.privacy.text" />
              </a>
              <span className="footer__link">
                <span id="ot-sdk-btn" className="ot-sdk-show-settings" title="Nastavenia súborov cookie">Nastavenia súborov cookie</span>
              </span>
              <a className="footer__link" href={intl.formatMessage({id: 'footer.disclaimer.url'})} target="_blank">
                <FormattedMessage id="footer.disclaimer.text" />
              </a>
            </div>
          </div>
          <div className="col col-12 col-md-4 pull-right footer__logo">
            <a href="http://www.lixil.com/" target="_blank">
              <svg width="104" height="18" viewBox="0 0 104 18" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fillRule="evenodd">
                  <path d="M53.676 12.607c-.41 0-.746-.316-.746-.706V2H49v10.56c0 1.9 1.628 3.44 3.637 3.44H58v-3.393h-4.324M99.676 12.607c-.41 0-.745-.316-.745-.706V2H95v10.56c0 1.9 1.628 3.44 3.637 3.44H104v-3.393h-4.324M61 16h4V2h-4M87 16h4V2h-4" fill="#DF572A"/>
                  <g>
                    <mask id="b" fill="#fff">
                      <path id="a" d="M41.494.276H.022V18h82.944V.276z"/>
                    </mask>
                    <path d="M78.194 8.623l4.772-6.24L79.913.277l-4.445 5.812L71.024.276 67.97 2.384l4.772 6.24c.216.282.216.745 0 1.03l-4.77 6.238L71.023 18l4.444-5.812L79.913 18l3.053-2.108-4.772-6.24c-.216-.283-.216-.746 0-1.03" fill="#DF572A" mask="url(#b)"/>
                    <path d="M1.784 6.288h.957c.88 0 1.32-.418 1.32-1.253s-.44-1.253-1.32-1.253h-.956v2.506zM0 11.25V2.382h2.573c2.198 0 3.27.983 3.27 2.653s-1.072 2.653-3.27 2.653h-.79v3.562H0z" fill="#4B4F50" mask="url(#b)"/>
                  </g>
                  <path d="M8.602 7.585h1.81l-.886-3.64H9.5l-.898 3.64zM6 11l2.364-9h2.338L13 11h-1.743l-.463-1.894H8.272L7.757 11H6zM15.754 5.914h.903c.775 0 1.245-.374 1.245-1.246 0-.873-.47-1.247-1.245-1.247h-.903v2.494zM18.118 11l-1.525-3.665h-.84V11H14V2h2.542c2.11 0 3.115.998 3.115 2.693 0 1.122-.407 1.932-1.386 2.293L20 11h-1.882zM27 2v1.52h-2.1V11h-1.8V3.52H21V2h6M32.816 8.283c0 .97.46 1.238 1.184 1.238s1.184-.266 1.184-1.237V4.717c0-.97-.46-1.237-1.184-1.237s-1.184.267-1.184 1.237v3.566zM31 4.935C31 2.775 32.237 2 34 2s3 .776 3 2.935v3.13C37 10.225 35.763 11 34 11s-3-.776-3-2.935v-3.13zM38 11V2h5v1.52h-3.083v2.07h2.416v1.52h-2.416V11H38" fill="#4B4F50"/>
                </g>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
);

Footer.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(Footer);



// WEBPACK FOOTER //
// ./src/components/common/footer.js